import Vue from 'vue'
import router from './router'
import LoginUserHelper from '@/utils/LoginUserHelper'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import {
  showErrMessage
} from '@/utils'


NProgress.configure({
  showSpinner: false
})

router.beforeEach(async (to, from, next) => {
  NProgress.start();
  console.log('路由变化:', to, from);
  const userInfo = LoginUserHelper.getUserInfo();
  const backUserInfo = JSON.parse(localStorage.getItem('backendUserInfo'))
  
  // 当前为默认路径或者登录页面时，判断是否存在用户身份信息以及token
  if (['/', 'login'].includes(to.name) && userInfo && userInfo.token) {
    next({
      name: 'landingPage',
    });
    return;
  } else if (['/', 'login'].includes(to.name) && to.query){
    next();
    return;
  }

  if (to.name == 'landingPage' && !userInfo) {
    next({
      path: '/login',
    })
  }


  if ((to.name == 'userList' || to.name == 'appList') && !backUserInfo) {
    next({
      path: '/landingPage',
    })
  }
  next();
})



router.afterEach((to, from) => {
  NProgress.done()
  window.scrollTo(0, 0)
})